import { render } from "./support-case-list.vue?vue&type=template&id=2c4288f0"
import script from "./support-case-list.vue?vue&type=script&lang=js"
export * from "./support-case-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__